import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BrButton } from '@govbr-ds/react-components';

export default function ExpertInstructionsPage() {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const dimensions = [
        { name: t('expert.dimensions.clarity'), description: t('expert.dimensions.clarityDesc'), icon: '💡' },
        { name: t('expert.dimensions.adequacy'), description: t('expert.dimensions.adequacyDesc'), icon: '🎯' },
        { name: t('expert.dimensions.consistency'), description: t('expert.dimensions.consistencyDesc'), icon: '🔄' },
        { name: t('expert.dimensions.accessibility'), description: t('expert.dimensions.accessibilityDesc'), icon: '♿' },
        { name: t('expert.dimensions.usability'), description: t('expert.dimensions.usabilityDesc'), icon: '👆' }
    ];

    return (
        <div className="container-lg py-4">
            <div className="row justify-content-center">
                <div className="col-12 col-lg-10">

                    {/* Header - Compact */}
                    <div className="text-center mb-4">
                        <span className="text-4xl">📖</span>
                        <h1 className="h2 mt-2 mb-1">{t('expert.instructionsPage.title')}</h1>
                        <p className="text-gray-60">{t('expert.instructionsPage.readCarefully')}</p>
                    </div>

                    {/* Content - No card wrapper */}
                    <div className="d-flex flex-column gap-4">

                        {/* O que você vai avaliar */}
                        <section>
                            <h2 className="h5 mb-2">🎯 {t('expert.instructionsPage.whatToEvaluate')}</h2>
                            <p className="text-gray-80 mb-0" dangerouslySetInnerHTML={{ __html: t('expert.instructionsPage.evaluateDesc') }} />
                        </section>

                        <hr className="my-1" />

                        {/* Índice IQAI - Simple list */}
                        <section>
                            <h2 className="h5 mb-2">📊 {t('expert.instructionsPage.iqaiIndex')}</h2>
                            <p className="text-gray-60 text-sm mb-3">
                                {t('expert.instructionsPage.iqaiDesc')}
                            </p>
                            <div className="d-flex flex-column gap-1">
                                {dimensions.map((dim) => (
                                    <p key={dim.name} className="mb-1">
                                        <span className="mr-2">{dim.icon}</span>
                                        <strong>{dim.name}</strong>
                                        <span className="text-gray-60"> — {dim.description}</span>
                                    </p>
                                ))}
                            </div>
                        </section>

                        <hr className="my-1" />

                        {/* Escala - Inline */}
                        <section>
                            <h2 className="h5 mb-2">⭐ {t('expert.instructionsPage.evaluationScale')}</h2>
                            <div className="d-flex flex-wrap gap-3 text-center">
                                <div><span className="text-xl">1</span><br /><small className="text-gray-60">{t('expert.scale.veryBad')}</small></div>
                                <div><span className="text-xl">2</span><br /><small className="text-gray-60">{t('expert.scale.bad')}</small></div>
                                <div><span className="text-xl">3</span><br /><small className="text-gray-60">{t('expert.scale.regular')}</small></div>
                                <div><span className="text-xl">4</span><br /><small className="text-gray-60">{t('expert.scale.good')}</small></div>
                                <div><span className="text-xl">5</span><br /><small className="text-gray-60">{t('expert.scale.excellent')}</small></div>
                            </div>
                        </section>

                        <hr className="my-1" />

                        {/* Dicas - Simple */}
                        <section>
                            <h2 className="h5 mb-2">💡 {t('expert.instructionsPage.importantTips')}</h2>
                            <div className="text-gray-80">
                                <p className="mb-1" dangerouslySetInnerHTML={{ __html: '✓ ' + t('expert.instructionsPage.tip1') }} />
                                <p className="mb-1">✓ {t('expert.instructionsPage.tip2')}</p>
                                <p className="mb-1">✓ {t('expert.instructionsPage.tip3')}</p>
                                <p className="mb-0">✓ {t('expert.instructionsPage.tip4')}</p>
                            </div>
                        </section>

                        {/* Tempo */}
                        <div className="text-center py-3 bg-gray-2 rounded">
                            <p className="mb-0">
                                ⏱️ <strong>{t('expert.instructionsPage.estimatedTime')}</strong> {t('expert.instructionsPage.minutes')}
                            </p>
                        </div>

                        {/* Botão */}
                        <BrButton
                            primary
                            onClick={() => {
                                window.scrollTo(0, 0);
                                navigate('/especialista/personas');
                            }}
                            className="w-100"
                            style={{ whiteSpace: 'normal', minHeight: '48px' }}
                            aria-label={t('expert.instructionsPage.meetPersonas')}
                        >
                            {t('expert.instructionsPage.meetPersonas')}
                        </BrButton>
                    </div>
                </div>
            </div>
        </div>
    );
}
